export const CURRENT_IN_SEASON_FOOTBALL = '25/26';
export const CURRENT_IN_SEASON_USSPORT = '25';

// seasonYear is the season's start year, so a calendar-year competition's 2026
// season (K League, MLS, J-League) shares the number with Europe's 2026-27 while
// still carrying the 2025-26 artwork.
export const usesCardDesign2026 = ({
  seasonYear,
  singleCivilYear,
}: {
  seasonYear: number;
  singleCivilYear: boolean;
}) => seasonYear >= 2026 && !singleCivilYear;

export const format = (
  seasonYear: number,
  {
    separator = '-',
    singleCivilYear = false,
  }: {
    separator?: string;
    singleCivilYear?: boolean;
  } = {}
) => {
  if (singleCivilYear) return seasonYear.toString();

  const next = (seasonYear + 1).toString().slice(-2);
  return `${seasonYear}${separator}${next}`;
};

export const formatFilter = (season: string) => format(parseInt(season, 10));
